module.exports = __webpack_public_path__ + "img/LogoImage.0add6687.png";